<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listTipoFaixa"
        title-table="Tipos de Faixa de Contribuição"
        module="tipoFaixaSettingsModule"
        sort-name="nome"
        :show-btn-add="verificarPermissao('ROLE_FINAN_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_FINAN_DELETAR')"
        @add="addNew"
        @edit="edit"
      >
        <template #buttons>
          <b-button
            variant="outline-secondary"
            class="ml-1"
            :to="{ name: 'mensalidades-dashboard' }"
          >
            <feather-icon icon="ChevronLeftIcon" />
            Voltar para Contribuições
          </b-button>
        </template>
      </TableComponents>
      <FormTipoFaixa
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol, BButton } from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'
import FormTipoFaixa from './forms/FormTipoFaixa.vue'

export default {
  name: 'TipoFaixaSetting',
  components: {
    BRow,
    BCol,
    BButton,
    TableComponents,
    FormTipoFaixa,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id',
        },
        {
          label: 'Nome',
          field: 'nome',
        },
        {
          label: 'Lançar Mensalidade',
          field: 'lancaMensalidade',
        },
        {
          label: 'Regra 1º Mês',
          field: 'regraPrimeiraMensalidade',
        },
        {
          label: 'Periodicidade',
          field: 'periodicidade',
        },
        {
          label: 'Lançar Titular',
          field: 'lancarNoTitular',
        },
        {
          label: this.$t('Active'),
          field: 'ativo',
        },
        {
          label: this.$t('Action'),
          field: 'action',
        },
      ],
    }
  },
  computed: {
    ...mapState('tipoFaixaSettingsModule', {
      listTipoFaixa: state => state.listTipoFaixa,
    }),
  },
  mounted() {
    this.$store.dispatch('tipoFaixaSettingsModule/loadTable', { size: 100 })
  },
  methods: {
    addNew() {
      this.$store.dispatch('tipoFaixaSettingsModule/resetTipoFaixa')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('tipoFaixaSettingsModule/prepareToEditTipoFaixa', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
      this.$store.dispatch('tipoFaixaSettingsModule/loadTable', { size: 100 })
    },
  },
}
</script>
